import * as actions from "./actions";
import { firebaseAuth, persistence, rootRef } from "../../config/firebase";

function userLogin({ email, password }) {
  return dispatch => {
    dispatch(actions.userLogin());
    firebaseAuth
      .setPersistence(persistence.LOCAL)
      .then(() =>
        firebaseAuth
          .signInWithEmailAndPassword(email, password)
          .then(() => dispatch(userObserver()))
          .catch(error => dispatch(actions.loginError(error)))
      )
      .catch(error => console.log(error));
  };
}

function userLogOut() {
  return dispatch =>
    firebaseAuth.signOut().catch(error => console.log("signOut Error:", error));
}

function userObserver() {
  return dispatch =>
    firebaseAuth.onAuthStateChanged(user => {
      dispatch(insertUserData(user));
      dispatch(actions.userLogged(user));
    });
}

function insertUserData(user) {
  return dispatch => {
    if (user === null) return;
    const { uid, displayName, email, photoURL, metadata } = user;
    const usr = {
      uid,
      displayName,
      email,
      photoURL,
      metadata
    };

    let insert = {};
    insert[`usuarios/perfiles/${uid}`] = usr;
    rootRef.update(insert);
  };
}

function resetError() {
  return actions.resetError();
}

/*---*/
export { userLogin, userLogOut, resetError };



// WEBPACK FOOTER //
// ./src/ducks/login/operations.js